import { MonetaryVerificationStatus } from '@percent/admin-dashboard/api/actions/monetaryVerifications/monetaryVerifications.types'

export const ALL_STATUSES_QUERY_VALUE = 'all'

const VALID_STATUSES = new Set<string>(Object.values(MonetaryVerificationStatus))

export const isValidStatus = (s: string | null): s is MonetaryVerificationStatus => s != null && VALID_STATUSES.has(s)

export const decodeStatuses = (statuses: readonly (string | null)[]): MonetaryVerificationStatus[] => {
  const validStatuses = [...new Set(statuses.filter(isValidStatus))]

  if (validStatuses.length || statuses.includes(ALL_STATUSES_QUERY_VALUE)) {
    return validStatuses
  }

  return [MonetaryVerificationStatus.PENDING]
}
